import create from 'zustand'
import { devtools } from 'zustand/middleware'
import { findBatch, range } from '../utils';
import { DateTime } from 'luxon'
import immer from "./immer"
let useFacultyFilesViewStore = (set, get) => ({
    subject: {},
    files: [],
    loading: true,
    setLoading: (a) => set(state => void (state.loading = a)),
    degree: {},
    branch: {},
    getSubjects: () => {
        console.log('Rendering subjects...');
        const a = get().subjects;
        return a;
        // return [{ _id: "none", name: "NONE" }, ...a];
    },
    addAll: (data) => set((state) => {
        console.log(data);
        state.subject = data.subject;
        state.files = data.files;
        state.loading = false;
    })
});
useFacultyFilesViewStore = devtools(useFacultyFilesViewStore, { name: "FacultyfilesView" });
useFacultyFilesViewStore = immer(useFacultyFilesViewStore);
export default create(useFacultyFilesViewStore);
